(function () {
    'use strict';

    angular
        .module('app.detailInfluencerGroup', [])
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('home.detailInfluencerGroup', {
                    requireLogin: true,
                    url: 'detailInfluencerGroup/:influencer_group_id',
                    templateUrl: 'app/influencerGroup/detailInfluencerGroup/detailInfluencerGroup.html?app_v=deployDate',
                    data: {
                        authorizedRoles: ['Administrator', 'User', 'Achoo Analyst'],
                        navMarker: ['detailInfluencerGroup']
                    },
                    controller: 'detailInfluencerGroupCtrl',
                    controllerAs: 'vm'
                })
        }]);
})();